import script from "./AccountPasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountPasswordReset.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__